var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddressEmty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "81.2406109px",
    viewBox: "0 0 89 81.2406109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-769.000000, -530.759389)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.137489,584 L858,588.960166 L834.275068,612 L821.833333,600.178732 L826.64293,595.168687 L834.222154,602.370627 L853.137489,584 Z M798.674579,530.759389 L824.017,536.916389 L846.875702,531.642146 C847.152237,531.57833 847.433535,531.538214 847.71654,531.522144 L848,531.514102 C850.761424,531.514102 853,533.752678 853,536.514102 L852.999616,575.61838 C851.113098,574.708309 849.10227,574.015189 846.999509,573.571398 L847,537.771102 L827,542.385389 L826.999804,577.315438 C824.734878,578.798845 822.710911,580.619747 820.999356,582.706692 L821,542.386 L801,537.771 L801,597.613 L815.033823,600.850637 C815.149261,603.150133 815.557811,605.372384 816.222866,607.480785 L797.985,603.081389 L775.124298,608.357854 C772.433591,608.978786 769.748976,607.300902 769.128044,604.610195 C769.042956,604.241482 769,603.864302 769,603.485898 L769,541.591025 C769,539.262745 770.607047,537.242605 772.875702,536.719069 L797.066,531.136389 L798.674579,530.759389 Z M795.416,537.674389 L775,542.386 L775,602.228 L795.031,597.605389 L795.416,537.674389 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddressEmty);
export default __webpack_public_path__ + "static/media/icon_address_emty.23b38967c6f4a65c041ec8dcd93f668a.svg";
export { ForwardRef as ReactComponent };